import CountryRegionData from 'country-region-data';

export const getCountryByShortcode = (shortcode: string) => CountryRegionData.find(item => item.countryShortCode === shortcode);

export const countries: CountryType[] = [
    {...getCountryByShortcode('AU')!, phone: '+61'},
    {...getCountryByShortcode('BR')!, phone: '+55'},
    {...getCountryByShortcode('CA')!, phone: '+1'},
    {...getCountryByShortcode('GB')!, phone: '+44'},
    {...getCountryByShortcode('HN')!, phone: '+504'},
    {...getCountryByShortcode('IN')!, phone: '+91'},
    {...getCountryByShortcode('MX')!, phone: '+52'},
    {...getCountryByShortcode('SA')!, phone: '+966'},
    {...getCountryByShortcode('ZA')!, phone: '+27'},
    {...getCountryByShortcode('MU')!, phone: '+230'},
    {...getCountryByShortcode('NA')!, phone: '+264'},
    {...getCountryByShortcode('US')!, phone: '+1', priority: 1},
];

export const sortedCountries = countries
    .sort((a: CountryType, b: CountryType) => {
        const nameA = a.countryName.toUpperCase(); // ignore upper and lowercase
        const nameB = b.countryName.toUpperCase(); // ignore upper and lowercase
        const priorityA = a.priority ? a.priority : -1;
        const priorityB = b.priority ? b.priority : -1;

        if (priorityA > priorityB) return -1
        if (priorityA < priorityB) return 1
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return 0;
    });

export interface RegionType {
    name: string;
    shortCode: string;
}

export interface CountryType {
    countryShortCode: string;
    countryName: string;
    phone: string;
    regions: RegionType[];
    priority?: number;
}

export default countries;
